<div class="user" *ngIf="userDetails$()" [ngClass]="{'isPreview':isPreview}" (click)="isUserDetailsOpen=true"
    #userDetailsTrigger>
    <span class="loggedUser">
        {{userDetails$()!.firstName.charAt(0).toUpperCase()}}{{userDetails$()!.lastName?.charAt(0)?.toUpperCase()}}
    </span>
    <img class="arrow" [ngClass]="{'open-img':isUserDetailsOpen}" src="/assets/images/header/arrow.svg" />
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="userDetailsTrigger"
        [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayOpen]="true"
        cdkConnectedOverlayBackdropClass="backdrop-selection" (backdropClick)="isUserDetailsOpen=false"
        [cdkConnectedOverlayOpen]="isUserDetailsOpen" [cdkConnectedOverlayPositions]="positonArea">
        <div class="overlay-warp wrapper">
            <div class="loggedUser big">
                <p> {{userDetails$()?.firstName?.charAt(0)?.toUpperCase()}}{{userDetails$()!.lastName?.charAt(0)?.toUpperCase()}}
                </p>
            </div>
            <div class="hi">
                <p>{{userDetails$()!.firstName}} {{userDetails$()!.lastName}}</p>
            </div>
            <hr class="hr">
            <div class="item justInMobile" (click)="goToBoardirector()">
                <div class="item-right">
                    <img src="/assets/images/header/mini-boardirector.svg" />
                    <p translate>header.boardirector</p>
                </div>
                <img class="scale-img" src="/assets/images/header/arrow-out.svg" />
            </div>
            <hr class="hr">
            <!-- <p *ngIf="userDetails$()!.isAdmin">Admin</p> -->
            <div class="item bottom" (click)="logOut()">
                <div class="item-right">
                    <img class="scale-img" src="/assets/images/header/logout.svg" />
                    <p translate>header.disconnect</p>
                </div>
            </div>
        </div>
    </ng-template>
</div>